module.exports = __webpack_public_path__ + "c47fa6ed0320068f64d6775c975a64aa.pdf";